import { Typography, TypographyProps } from 'antd';

import { Card, CardProp } from '@hdi-seguros/web-components.card';
import { RowSize } from '../RowSize';

import { COLORS } from '../../../config/themes/colors';
import './index.css';

interface SectionQuotationProps {
  cardProps?: CardProp;
  children: React.ReactNode;
  hasCard?: boolean;
  level?: 'h1' | 'h2' | 'h3' | 'h4';
  styles?: React.CSSProperties;
  title?: string;
  titleCard?: string | JSX.Element;
  typographyProps?: TypographyProps;
}

export const ContentSection = ({
  cardProps,
  hasCard = true,
  level = 'h3',
  styles,
  title,
  titleCard,
  typographyProps,
  children,
}: SectionQuotationProps) => {
  const levelMap: Record<string, 1 | 2 | 3 | 4 | 5> = {
    h1: 1,
    h2: 2,
    h3: 3,
    h4: 4,
  };

  const levelSize = levelMap[level];

  return (
    <div className='sectionQuotation w-100 mt-1'>
      {title && (
        <RowSize rowProps={{ gutter: [0, 15] }}>
          <Typography.Title
            level={levelSize}
            className='title'
            style={{ color: COLORS.secondary[100], ...styles }}
            {...typographyProps}
          >
            {title}
          </Typography.Title>
        </RowSize>
      )}
      <RowSize className='p-15 w-auto'>
        <Card
          {...cardProps}
          title={titleCard}
          className={`${hasCard ? '' : 'not-padding add-transparent'}`}
        >
          {children}
        </Card>
      </RowSize>
    </div>
  );
};
